module.exports = __webpack_public_path__ + "static/img/gift-4.03811bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-4.png
// module id = 364
// module chunks = 140